<template>
  <b-container fluid class="history-container">
    <h2 class="asset-header">
      {{
        `Platine ${
          friendlyName
            ? friendlyName
            : currentAssetReference || $route.params.assetId
        }`
      }}
      - Historique de maintenance
    </h2>
    <b-row>
      <b-col>
        <b-form-group
          label=""
          label-cols="9"
          label-size="sm"
          label-align="right"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="overflow-auto">
      <b-table
        ref="table"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        small
        show-empty
      >
        <template #empty="scope">
          <span>{{ scope.emptyText }}</span>
        </template>
        <template #emptyfiltered="scope">
          <span>{{ scope.emptyFilteredText }}</span>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
      ></b-pagination>
    </div>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'MaintenanceHistory',
  components: {},
  computed: {
    ...mapGetters('auth', ['currentLoggedinUser', 'currentTenant']),
    ...mapGetters('asset', ['currentAssetReference'])
  },
  watch: {
    'currentTenant.index'(newValue) {
      this.$refs.table.refresh();
    }
  },
  data() {
    return {
      isBusy: false,
      friendlyName: null,
      fields: [
        { key: 'timestamp', label: 'Date' },
        { key: 'value', label: 'Status' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 25]
    };
  },
  methods: {
    async myProvider(ctx) {
      this.isBusy = true;
      try {
        const tenant = this.currentTenant.index;
        const { result: asset } = await this.$kuzzle.query({
          controller: 'device-manager/assets',
          action: 'get',
          _id: this.$route.params.assetId,
          engineId: this.currentTenant.index
        });

        this.friendlyName =
          asset._source.metadata.friendlyName || asset._source.reference;

        const searchResult = await this.$kuzzle.document.search(
          tenant,
          'assets-history',
          {
            query: {
              and: [
                { equals: { id: asset._id } },
                { equals: { 'event.metadata.names': 'maintenance' } }
              ]
            },
            sort: {
              '_kuzzle_info.createdAt': 'desc'
            }
          },
          {
            size: this.perPage,
            from: (this.currentPage - 1) * this.perPage,
            lang: 'koncorde'
          }
        );

        this.totalRows = searchResult.total;
        this.isBusy = false;

        return searchResult.hits.map(hit => ({
          value:
            'Maintenance: ' +
            (hit._source.asset.metadata.maintenance ? 'On' : 'Off'),
          timestamp: this.formatDate(hit._source._kuzzle_info.createdAt)
        }));
      } catch (error) {
        console.error(error);
        this.isBusy = false;
        return [];
      }
    },
    formatDate(timetamp) {
      return moment(timetamp).format('YYYY/MM/DD HH:mm:ss');
    }
  }
};
</script>

<style lang="scss">
.history-container {
  padding: 20px;
}

.asset-header {
  text-align: left;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #efefef;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dddddd;
  border-color: #dddddd;
}

.page-link {
  color: #b9b9b9;
}

.pagination {
  justify-content: flex-end;
}

@media (max-width: 767.98px) {
  .asset-header {
    font-size: 1.25rem;
  }
}
</style>
